export * from './drag-and-drop.module';
export * from './draggable-helper.provider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/angular-draggable-droppable/dist/esm/src/index.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/index.js
// module chunks = vendor